module.exports = __webpack_public_path__ + "static/img/cnc1.57d0b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cnc1.jpg
// module id = 8PD4
// module chunks = 2